import { render, staticRenderFns } from "./ExcTextarea.vue?vue&type=template&id=539c1b7a&scoped=true&"
import script from "./ExcTextarea.vue?vue&type=script&lang=js&"
export * from "./ExcTextarea.vue?vue&type=script&lang=js&"
import style0 from "./ExcTextarea.vue?vue&type=style&index=0&id=539c1b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539c1b7a",
  null
  
)

export default component.exports